import { toast } from 'sonner';
import { postApiCall } from '@/service/httpCall';
import { API_USER_BULK_STATUS } from '@/service/url';

type Entry = { id: number; username?: string; reason?: string };
type BulkStatusResult = { updated?: Entry[]; skipped?: Entry[]; failed?: Entry[] };

const namesText = (names: string[]) =>
  names.length > 5 ? `${names.slice(0, 5).join(', ')} +${names.length - 5} more` : names.join(', ');

export async function bulkSetUserStatus(
  userIds: number[],
  status: 0 | 1,
  noun: string,
  nameOf: (id: number) => string | undefined = () => undefined,
): Promise<boolean> {
  let res: BulkStatusResult;
  try {
    res = (await postApiCall(API_USER_BULK_STATUS, { userIds, status })) as BulkStatusResult;
  } catch {
    return false;
  }
  const label = (e: Entry) => nameOf(e.id) || e.username || `#${e.id}`;
  const byReason = (list: Entry[]) => {
    const groups = new Map<string, string[]>();
    list.forEach((e) => groups.set(e.reason || 'Unknown', [...(groups.get(e.reason || 'Unknown') || []), label(e)]));
    return [...groups].map(([reason, names]) => `${reason}: ${namesText(names)}`).join(' · ');
  };
  const updated = res?.updated || [];
  const skipped = res?.skipped || [];
  const failed = res?.failed || [];
  if (updated.length) toast.success(`${updated.length} ${noun}(s) ${status === 0 ? 'blocked' : 'unblocked'}`);
  if (skipped.length) toast.warning(`Skipped ${skipped.length}`, { description: byReason(skipped) });
  if (failed.length) toast.error(`Failed ${failed.length}`, { description: byReason(failed) });
  return true;
}
